import { useMemo } from "react";
import { BLOG_SEARCH_MIN_LENGTH } from "../constants/blog";

/**
 * Filters a list of articles by a free-text query.
 *
 * Searches across title, description, category, and tags.
 * Returns all articles when the query is shorter than BLOG_SEARCH_MIN_LENGTH.
 *
 * @param {Array<import("../blog").ArticleShape>} articles - Full article list
 * @param {string} query - Raw search string from the user
 * @returns {{ results: Array, isFiltered: boolean }}
 */
export function useBlogSearch(articles, query) {
  const trimmed = (query || "").trim();
  const isFiltered = trimmed.length >= BLOG_SEARCH_MIN_LENGTH;

  const results = useMemo(() => {
    if (!isFiltered) return articles;
    const q = trimmed.toLowerCase();
    return articles.filter(
      (a) =>
        a.title.toLowerCase().includes(q) ||
        a.description.toLowerCase().includes(q) ||
        a.category.toLowerCase().includes(q) ||
        a.tags.some((t) => t.toLowerCase().includes(q))
    );
  }, [articles, trimmed, isFiltered]);

  return { results, isFiltered };
}
